import { useQuery } from "react-query";
import { restoreUserId, secureAxios } from "../../_helpers/auth";

const userId = restoreUserId();

// const DEFAULT_IMG_FILTERS = `filter[type][_starts_with]=image&filter[hidden][_eq]=false&filter[archived][_eq]=false&filter[uploaded_by][_eq]=${userId}`;
const DEFAULT_IMG_FILTERS = `filter[type][_starts_with]=image&filter[hidden][_eq]=false&filter[archived][_eq]=false&filter[uploaded_by][_eq]=$CURRENT_USER`;

const TRASH_IMAGE_FILTERS = `filter[type][_starts_with]=image&filter[hidden][_eq]=false&filter[archived][_eq]=true&filter[uploaded_by][_eq]=$CURRENT_USER`;

const BASE_IMG_FILTERS =
    "filter[hidden][_eq]=false&filter[archived][_eq]=false";

export const useFiles = (filterString, enabled) => {
    return useQuery(
        ["files", filterString],
        // () => secureAxios.get(`/files`).then((res) => res.data),
        () =>
            secureAxios
                .get(
                    `/files?fields=id,filename_disk&sort=-uploaded_on&${DEFAULT_IMG_FILTERS}&${filterString}&meta=*`
                )
                .then((res) => res),
        {
            enabled: enabled,
        }
    );
};

export const useTrashFiles = (filterString, enabled) => {
    return useQuery(
        ["files", filterString],
        async () => {
            const fullUrl = `/files?fields=id,filename_disk&sort=-uploaded_on&${TRASH_IMAGE_FILTERS}&${filterString}&meta=*`;

            const res = await secureAxios.get(fullUrl);

            return res;
        },
        {
            enabled: enabled,
        }
    );
};

export const useAllFiles = (filterString = "", enabled = true) => {
    return useQuery(
        ["items", "directus_files", filterString],
        () =>
            secureAxios
                .get(
                    `/files?fields=id,filename_disk,type,hidden,collection,title&sort=-uploaded_on&${BASE_IMG_FILTERS}&${filterString}&meta=*`
                )
                .then((res) => res),
        {
            enabled,
        }
    );
};
